import { useEffect, useState } from "react";

// Countdown that always ticks between 15h and 12h — never expires, never stalls
function calc() {
    const now = new Date();
    const midnight = new Date(now);
    midnight.setHours(0, 0, 0, 0);
    const CYCLE = 3 * 3.6e6; // every 3 hours it rolls over
    const MAX = 15 * 3.6e6; // starts at 15h, ends at 12h, restarts
    const elapsed = (now.getTime() - midnight.getTime()) % CYCLE;
    const diff = Math.max(0, MAX - elapsed);
    return {
        h: Math.floor(diff / 3.6e6),
        m: Math.floor((diff % 3.6e6) / 6e4),
        s: Math.floor((diff % 6e4) / 1e3),
    };
}

export function useCountdown() {
    const [t, setT] = useState(calc);
    useEffect(() => {
        const i = setInterval(() => setT(calc()), 1000);
        return () => clearInterval(i);
    }, []);
    return t;
}

export function pad(n) {
    return String(n).padStart(2, "0");
}
